import { render, staticRenderFns } from "./ListagemInquilinos.vue?vue&type=template&id=758f9418"
import script from "./ListagemInquilinos.vue?vue&type=script&lang=js"
export * from "./ListagemInquilinos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports